import { type BrandVariants, createLightTheme } from '@fluentui/react-components';

const themeColors: BrandVariants = {
    10: '#020403',
    20: '#111B17',
    30: '#182E26',
    40: '#1C3B30',
    50: '#20493B',
    60: '#245746',
    70: '#286651',
    80: '#2B755D',
    90: '#3E836B',
    100: '#54907A',
    110: '#699D89',
    120: '#7EAB99',
    130: '#92B8A9',
    140: '#A7C5B9',
    150: '#BCD3C9',
    160: '#D1E1DA',
};

export const lightTheme = createLightTheme(themeColors);

export const chartColors = {
    chartColor1: '#C4D41B',
    chartColor2: '#007B5C',
    chartColor3: '#F05454',
    chartColor4: '#3B82F6',
    chartColor5: '#FFB800',
    chartColor6: '#7B7BA5',
    chartColor7: '#1F2844',
    chartColor8: '#8B4A5F',
    chartColor9: '#4E8A2F',
    chartColor10: '#2F5C99',
    chartColor11: '#FF7A1F',
    chartColor12: '#4B7A6C',
    chartColor13: '#6E6343',
    chartColor14: '#4D2A3D',
    chartColor15: '#B58863',
    chartColor16: '#9A9A82',
    chartColor17: '#9B6B96',
    chartColor18: '#FF7A1F',
    chartColor19: '#4B8A2A',
    chartColor20: '#566163',
    chartColor21: '#CC7A33',
    chartColor22: '#FFFFFF',
    chartColor23: '#4D2A3D',
    chartColor24: '#F4F4F5',
};
